import "core-js/modules/es.array.includes.js";
import React from 'react';
import { getProductTypeById, getFundDisplayName, getProductManager } from '@finect/front-resources/Products';
import { SceneLink } from '@finect/front-core/Routes';
import { Flex } from '@finect/tabular-core/Flex';
import { Icon } from '../../Icon';
import { InfoLabel } from '../../Products';
import { Inner, ProductTitle, IconBlock, OrganizationLabel } from './partials';
export var Product = function Product(_ref) {
  var product = _ref.product,
    _ref$iconType = _ref.iconType,
    iconType = _ref$iconType === void 0 ? 'manager' : _ref$iconType;
  var entity = product.entity,
    subtype = product.subtype;
  var productType = getProductTypeById(subtype);
  var manager = getProductManager(product);
  var iconPath = manager ? "/image/".concat(manager.icon) : null;
  var productName = getFundDisplayName(entity, productType);
  return React.createElement(Inner, null, React.createElement(IconBlock, null, ['manager'].includes(iconType) ? React.createElement(Icon, {
    withBorder: true,
    size: 3,
    type: "company",
    image: iconPath,
    alt: manager ? manager.displayName : productName
  }) : null, ['product'].includes(iconType) ? React.createElement(Icon, {
    withBorder: true,
    size: 4,
    type: "storefront",
    image: product.entity.image,
    alt: productName
  }) : null), React.createElement("div", null, React.createElement(OrganizationLabel, null, productType.shortSingular), React.createElement(SceneLink, {
    as: ProductTitle,
    scene: productType.category === 'iic' ? 'FundSheet' : 'ProductSheet',
    isin: entity.isin,
    alias: entity.alias,
    productSlug: entity.alias,
    productTypeSlug: productType.slug,
    typeSlug: productType.slug
  }, productName), React.createElement(Flex, {
    align: "center",
    style: {
      marginTop: '4px'
    }
  }, entity.performance ? React.createElement("div", {
    style: {
      zoom: 0.85,
      marginRight: '9px'
    }
  }, React.createElement(InfoLabel, {
    value: entity.performance.value,
    unit: "percent",
    label: "3A",
    tooltip: {
      tip: 'Rentabilidad anualizada a 3 años',
      from: 'right'
    }
  })) : null)));
};